<template>
  <div>
    <keep-alive :exclude="excludeRoutes">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import { getUrlParams } from "@/utils/url";

export default {
  name: "App",
  computed: {
    excludeRoutes({ $store }) {
      return $store.state.keeps.routesName;
    },
  },
  created() {
    const spiId = {
      'wX4yZ5aB6cD7eF8g': 'i0tcc76940464ddewgnb4938h9e5rh8e',
      '8LmN9oP0qR1sT2uV': 'bd4354bd750446b59099f9a629fb48ae',
      'aB3cD4eF5gH6iJ7k': '893c09e7553d4f4ca28befa52e64153e',
      'iB3cD4eF5gH6iJ7k': '4y5k51bqqc8663om96e71fzed9g52zi6',
      '4Fg8H2jK7LmN3PqR': 'c9ccc76940464dc7bed33e0f9da9cf99',
      'bPd5yFSq5WUToDNq': '66889308b82d49c49f2cddd41269e64d',
      'M46XrqO1PTBlO2je': 'ae5df089040511ed81da00163e0ee4f3',
      '9wvmnhVizPKLHsoq': 'eu9k48168759f69c018759f69c670000',
    }
    let { EntId, mtBmUid, saleId, uid } = getUrlParams(window.location.href);
    try {
      if (location.hash.indexOf("handing") == -1) {
        if (EntId === 'wX4yZ5aB6cD7eF8g') {
          this.$router.replace({
            name: 'ShenZhenDianXinManTuo',
            query: {
              channel: 'MT',
              EntId,
              mtBmUid,
              saleId,
              uid
            }
          })
        } else if (EntId === '8LmN9oP0qR1sT2uV') {
          this.$router.replace({
            name: 'GuangZhouDianXinManTuo',
            query: {
              channel: 'MT',
              EntId,
              mtBmUid,
              saleId,
              uid
            }
          })
        } else if (EntId === 'M46XrqO1PTBlO2je') {
          this.$router.replace({
            name: 'HuNanLianTongManTuo',// 饿了么
            query: {
              channel: 'MT',
              EntId,
              mtBmUid,
              saleId,
              uid
            }
          })
        } else if (EntId === 'aB3cD4eF5gH6iJ7k') {
          this.$router.replace({
            name: 'GuangZhouLianTongManTuo',
            query: {
              channel: 'MT',
              EntId,
              mtBmUid,
              saleId,
              uid
            }
          })
        } else if (EntId === 'iB3cD4eF5gH6iJ7k') {
          this.$router.replace({
            name: 'GuangZhouLianTongManTuo',
            query: {
              channel: 'MT',
              EntId,
              mtBmUid,
              saleId,
              uid
            }
          })
        } else if (EntId === '4Fg8H2jK7LmN3PqR') {
          this.$router.replace({
            name: 'ZhongGuoLianTongManTuo',
            query: {
              channel: 'MT',
              EntId,
              mtBmUid,
              saleId,
              uid
            }
          })
        } else if (EntId === '9wvmnhVizPKLHsoq') {
          this.$router.replace({
            name: 'GuangZhouLianTong', // 饿了么
            query: {
              channel: 'MT',
              EntId,
              mtBmUid,
              saleId,
              uid
            }
          })
        } else if (EntId === 'bPd5yFSq5WUToDNq') {
          this.$router.replace({
            name: 'JiangShuLianTongManTuo', // 饿了么
            query: {
              channel: 'MT',
              EntId,
              mtBmUid,
              saleId,
              uid
            }
          })
        } else if (EntId == undefined) {
          this.$router.push({
            name: "notData",
          });
        }
      }
      localStorage.setItem('EntId', EntId)
      localStorage.setItem('spiId', spiId[EntId])
      localStorage.setItem("mtBmUid", mtBmUid);
      localStorage.setItem("saleId", saleId);
      localStorage.setItem("uid", uid);
    } catch (err) {
      console.log(err)
    }
  }
};
</script>

<style></style>
